/**
 * Dashboard imagery. Held in one place so the art direction stays consistent
 * and a swap is a data change rather than an edit across components.
 */
export const dashboardImages = {
  /** Hero illustration — student, waving, on the brand teal field. */
  heroStudent:
    'https://cdn.magicpatterns.com/patterns/generated-images/02988210-160c-45f9-a8ce-131c1ce91799.jpg',
  /** Property photograph for the housing application card. */
  housing:
    'https://cdn.magicpatterns.com/patterns/generated-images/38042f71-fc7f-470e-b824-4e31b1d2dec6.jpg',
  /** Pale campus skyline used as a decorative field behind event content. */
  campus:
    'https://cdn.magicpatterns.com/patterns/generated-images/3d6bcdb8-72cf-42dd-9539-7b357744bb4f.jpg',
  /** Premium mark for the Campuzon Plus banner. */
  crown:
    'https://cdn.magicpatterns.com/patterns/generated-images/94fe1e07-fa8b-4531-b886-448312c0d303.jpg',
} as const
